// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
// needed to support IE 9/10/11 as of 2016/02 (JMD)

(function(window) {
   'use strict';

   try {
      /* eslint no-new:'off' */
      new window.CustomEvent('test');
   } catch (e) {
      var CustomEvent = function(event, params) {
         var evt;
         params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
         };

         evt = document.createEvent('CustomEvent');
         evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
         return evt;
      };

      CustomEvent.prototype = window.Event.prototype;
      window.CustomEvent = CustomEvent; // expose definition to window
   }
}(this));
